// tslint:disable
/**
 * Audit
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { SecurityImageKeyRequest } from '../models';
import { SecurityImageKeyResponse } from '../models';
/**
 * SecurityApi - axios parameter creator
 * @export
 */
export const SecurityApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {SecurityImageKeyRequest} [securityImageKeyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    securitySecurityImageKeyPost(
      securityImageKeyRequest?: SecurityImageKeyRequest,
      options: any = {}
    ): RequestArgs {
      const localVarPath = `/security/security-image-key`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof securityImageKeyRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(securityImageKeyRequest !== undefined ? securityImageKeyRequest : {})
        : securityImageKeyRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SecurityApi - functional programming interface
 * @export
 */
export const SecurityApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {SecurityImageKeyRequest} [securityImageKeyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    securitySecurityImageKeyPost(
      securityImageKeyRequest?: SecurityImageKeyRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityImageKeyResponse> {
      const localVarAxiosArgs = SecurityApiAxiosParamCreator(
        configuration
      ).securitySecurityImageKeyPost(securityImageKeyRequest, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * SecurityApi - factory interface
 * @export
 */
export const SecurityApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {SecurityImageKeyRequest} [securityImageKeyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    securitySecurityImageKeyPost(
      securityImageKeyRequest?: SecurityImageKeyRequest,
      options?: any
    ): AxiosPromise<SecurityImageKeyResponse> {
      return SecurityApiFp(configuration).securitySecurityImageKeyPost(
        securityImageKeyRequest,
        options
      )(axios, basePath);
    },
  };
};

/**
 * SecurityApi - object-oriented interface
 * @export
 * @class SecurityApi
 * @extends {BaseAPI}
 */
export class SecurityApi extends BaseAPI {
  /**
   *
   * @param {SecurityImageKeyRequest} [securityImageKeyRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SecurityApi
   */
  public securitySecurityImageKeyPost(
    securityImageKeyRequest?: SecurityImageKeyRequest,
    options?: any
  ) {
    return SecurityApiFp(this.configuration).securitySecurityImageKeyPost(
      securityImageKeyRequest,
      options
    )(this.axios, this.basePath);
  }
}
